// src/components/MailingListSignup.tsx
//
// The footer's "Join our mailing list" block.
//
// There is no first-party subscribe endpoint — Square's hosted outreach page is
// the only place a subscriber can actually be created. Embedding that page is
// what MailingListForm does, and it cannot be styled to match this layout;
// it also fires Square's pixel_tracking page_view on load, which is why that
// component is gated on cookie consent (see src/lib/consent.ts).
//
// So this block renders the designed field and hands the visitor off to Square
// on submit: a user-initiated navigation rather than a tracker we injected, so
// it needs no consent gate. The typed address is NOT put in the URL — an email
// in a query string leaks into history, logs and referrers — so Square asks for
// it again on its own page.
import React, { useEffect, useState } from "react";
import { getSquareKeys, SquareKeys } from "../api";

const MailingListSignup = () => {
  const [squareKeys, setSquareKeys] = useState<SquareKeys | null>(null);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const getKeys = async () => {
      const keysResponse = await getSquareKeys();
      if (keysResponse?.data && !keysResponse.error) {
        setSquareKeys(keysResponse.data);
      } else {
        console.error("Error getting keys.", keysResponse?.error);
      }
    };

    getKeys();
  }, []);

  const signupUrl = squareKeys
    ? `https://squareup.com/outreach/g4De4w/subscribe?location_id=${squareKeys.locationId}`
    : null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!signupUrl) return;
    window.open(signupUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="site-footer__signup">
      <h2 className="site-footer__heading">Join our mailing list</h2>
      <p className="site-footer__subheading">
        for exclusive offers, new arrivals and more.
      </p>
      <form className="site-footer__form" onSubmit={handleSubmit}>
        <label className="sr-only" htmlFor="footer-email">
          Email Address
        </label>
        <input
          id="footer-email"
          type="email"
          name="email"
          autoComplete="email"
          placeholder="Email Address"
          className="site-footer__input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          type="submit"
          className="site-footer__submit"
          disabled={!signupUrl}
        >
          Sign up
        </button>
      </form>
    </div>
  );
};

export default MailingListSignup;
